export const environment = {
  uriBase: 'https://qa.back.cvu.com.co/api/ms-admin/v1/',
  uriOpenData: 'https://www.datos.gov.co/resource/gdxc-w37w.json?$select=',
};
